import * as angular from 'angular';

class StorageLocationDetailsEditCtrl implements ng.IController {
    public storageLocationId: boolean;
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public loggedInUser: LoginResult;
    public displayName: string;

    constructor(private $window) {}

    $onInit() {
        if (this.isCreateMode) {
            this.storageLocation = <StorageLocationDto>{
                ssoId: this.loggedInUser.referenceId,
                ssoName: this.loggedInUser.tsoName,
                validity: {}
            };
        }
        if (this.isEditMode) {
            this.displayName = angular.copy(this.storageLocation.name);
        }
    }

    public goBack(): void {
        this.$window.history.back();
    }
}

angular.module('app').component('pkpStorageLocationDetailsEdit', {
    controller: StorageLocationDetailsEditCtrl,
    template:
        require('app/storage-location/storage-location-details-edit.component.html'),
    bindings: {
        form: '=',
        loggedInUser: '<',
        storageLocationId: '<?',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
